import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Stack from "@mui/material/Stack";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopTimePicker } from "@mui/x-date-pickers/DesktopTimePicker";
import { ErrorMessage, FormikProps, FormikValues, useFormikContext, useField, getIn } from "formik";

const TimePicker = (props: any) => {
  const { label, disabled, errorText, id, name, ...rest } = props;
  const [field] = useField(props);
  const formik: FormikProps<FormikValues> = useFormikContext();

  const handleChange = (newValue: any) => {
    formik.setFieldValue(field.name, newValue);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Stack spacing={3}>
        <DesktopTimePicker
          value={field.value}
          onChange={handleChange}
          disabled={disabled}
          renderInput={(params: any) => {
            return (
              <TextField
                fullWidthvalue
                label={label}
                name={name}
                id={id}
                helperText={<ErrorMessage name={name} />}
                error={getIn(formik.touched, name) && getIn(formik.errors, name)}
                {...rest}
                {...params}
              />
            );
          }}
        />
      </Stack>
    </LocalizationProvider>
  );
};

export default TimePicker;
